import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { lassoForm, Text, TextArea, validator } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
  @media (min-width: 768px) {
    margin-right: -30px;
  }
  label {
    font-weight: bold;
    font-size: 13px;
    color: #FFF;
    margin-bottom: 5px;
    text-transform: uppercase;
    .required {
      color: #dc3545;
    }
    @media (min-width: 768px) {
      font-size: 15px;
      letter-spacing: 3px;
      margin-bottom: 7px;
    }
  }
  .form-row {
    display: block;
    width: 100%;
    height: auto;
    @media(min-width: 768px) {
      display: flex;
      flex-direction: row;
      margin: 0 0 30px 0;
    }
    .col {
      margin: 0 0 20px 0;
      @media(min-width: 768px) {
        padding: 0 30px 0 0;
        margin: 0;
      }
    }
  }
  .form-control:not(textarea) {
    height: 38px;
  }
  input, select, textarea {
    border-radius: 0;
    border: none;
    font-weight: 400;
    font-size: 16px;
    color: ${colors.color5};
  }
  input, select {
    padding: 5px 15px;
  }
  textarea {
    padding: 10px 15px;
    @media (min-width: 768px) {
      padding: 15px 15px;
    }
  }
  .is-invalid {
    border: 1px solid #dc3545;
  }
  .btn[type="submit"] {
    color: black;
    &:hover {
      color: ${colors.color1};
    }
  }
  .ReportForm_header{
    font-family: ${typography.SerifHead};
    font-style: italic;
    font-weight: 600;
    text-align:center;
  }
`;


const thankYouStyles = css`
  .ReportForm_thankYouHeader {
    font-family: ${typography.SerifHead};
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.151515;
    padding-bottom: 28px;
    margin-bottom: 23px;
    position: relative;
    font-style: italic;
    @media (min-width: 768px) {
      font-size: 28px;
      padding-bottom: 22px;
      margin-bottom: 18px;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 75px;
      height: 3px;
      background-color: #CDAB35;
    }
  }
  .ReportForm_thankYouCopy {
    font-size: 16px;
    line-height: 2.0625;
    color: #484941;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 20px;
      font-weight: 300;
      line-height: 1.863636;
    }
  }
`;


function validate(values) {
  const response = {
    firstName: null,
    lastName: null,
    email: null,
    yourAddress: null,
    problemAddress: null,
    problem: null,
  };
  if (!values.firstName) {
    response.firstName = {
      error: 'First Name is required',
    };
  }
  if (!values.lastName) {
    response.lastName = {
      error: 'Last Name is required',
    };
  }
  if (!values.yourAddress) {
    response.yourAddress = {
      error: 'Your Address is required',
    };
  }
  if (!values.problemAddress) {
    response.problemAddress = {
      error: 'Address of Problem is required',
    };
  }
  if (!values.problem) {
    response.problem = {
      error: 'Problem is required',
    };
  }
  if (!values.email) {
    response.email = {
      error: 'Email is required',
    };
  } else if (!validator.isEmail(values.email)) {
    response.email = {
      error: 'Email must be valid',
    };
  }
  return response;
}


class ReportForm extends React.Component {
  constructor(props) {
    super(props);

    const { formApi } = props;

    formApi.setValue('formName', 'contactUs');
    formApi.setValue('formLabel', 'Contact Us');

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.success && !this.props.success) {
      this.props.onSuccess();
    }
  }

  render() {
    const { formApi, success, noRedirect } = this.props;

    function getError(field) {
      return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
    }

    function getErrorClass(field) {
      if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
        return 'is-invalid';
      }

      return null;
    }

    if (success) {
      return (
        <div className={thankYouStyles}>
          {
            !noRedirect &&
            <Redirect
              name="contact-us-thank-you"
            />
          }
          {
            noRedirect &&
            <div>
              <h4 className="ReportForm_thankYouHeader GoldText">Thank You</h4>
              <p className="ReportForm_thankYouCopy">
                We have recieved your message and will respond as soon as possible.
              </p>
            </div>
          }
        </div>
      );
    }

    return (
      <div className={styles}>
        <h3 className="ReportForm_header GoldText">Submit Property Report Request</h3>
        <div className="form-row">
          <div className="col">
            <label htmlFor="ReportForm_firstName">First Name <span className="required">*</span></label>
            <Text
              id="ReportForm_firstName"
              field="firstName"
              name="firstName"
              className={`form-control ${getErrorClass('firstName')}`}
            />
            <div className="invalid-feedback">
              {getError('firstName')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="ReportForm_lastName">Last Name <span className="required">*</span></label>
            <Text
              id="ReportForm_lastName"
              field="lastName"
              name="lastName"
              className={`form-control ${getErrorClass('lastName')}`}
            />
            <div className="invalid-feedback">
              {getError('lastName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="ReportForm_firstName">Your Address <span className="required">*</span></label>
            <Text
              id="ReportForm_yourAddress"
              field="yourAddress"
              name="yourAddress"
              className={`form-control ${getErrorClass('yourAddress')}`}
            />
            <div className="invalid-feedback">
              {getError('yourAddress')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="ReportForm_email">Email <span className="required">*</span></label>
            <Text
              id="ReportForm_email"
              field="email"
              name="email"
              className={`form-control ${getErrorClass('email')}`}
            />
            <div className="invalid-feedback">
              {getError('email')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="ReportForm_phone">Phone</label>
            <Text
              id="ReportForm_phone"
              field="phone"
              name="phone"
              className="form-control"
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="ReportForm_firstName">Address of Problem <span className="required">*</span></label>
            <Text
              id="ReportForm_problemAddress"
              field="problemAddress"
              name="problemAddress"
              className={`form-control ${getErrorClass('problemAddress')}`}
            />
            <div className="invalid-feedback">
              {getError('problemAddress')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="ReportForm_cityRep">If this is an issue with the City of Broken Arrow, have you contacted the city?<br />If so, who did you speak with?</label>
            <Text
              id="ReportForm_cityRep"
              field="cityRep"
              name="cityRep"
              className={`form-control ${getErrorClass('cityRep')}`}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="ReportForm_problem">Description of Problem <span className="required">*</span></label>
            <TextArea
              id="ReportForm_problem"
              field="problem"
              name="problem"
              className="form-control"
              rows="4"
            />
            <div className="invalid-feedback">
              {getError('problem')}
            </div>
          </div>
        </div>
        <button type="submit" className="Btn Hollow">Send</button>
      </div>
    );
  }
}

ReportForm.propTypes = {
  formApi: PropTypes.object.isRequired,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  noRedirect: PropTypes.bool,
};

ReportForm.defaultProps = {
  success: undefined,
  onSuccess: () => {},
  noRedirect: false,
};

export default lassoForm({
  validate,
})(ReportForm);



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/ReportForm.js